export default __webpack_public_path__ + "arrow-left.aff135bc41999c633dc1c61c30c3d798.svg";